module.exports = __webpack_public_path__ + "img/calendar.140ef50f.svg";